import { DayPopover } from '@/domain/termine/features/Calendar/Grid/DayCell/Popover/DayPopover';
import { DayPopoverContext } from '@/domain/termine/features/Calendar/Grid/DayCell/Popover/DayPopoverContext';
import { TerminEntry } from '@/domain/termine/features/Calendar/Grid/Termin/TerminEntry';
import { FeiertagEntry } from '@/domain/termine/features/Calendar/Grid/Feiertag/FeiertagEntry';
import { Termin } from '@/domain/termine/shared/types/Termin';
import dayjs from 'dayjs';
import { useCalendarContext } from '@/domain/termine/features/Calendar/shared/CalendarContext';

interface DayCellDesktopEntriesProps {
  visible: Termin[];
  hidden: Termin[];
  day: dayjs.Dayjs;
}

export function DayCellDesktopEntries({
  visible,
  hidden,
  day,
}: DayCellDesktopEntriesProps) {
  const { feiertage } = useCalendarContext();
  return (
    <div className="flex-col hidden lg:block relative group">
      <DayPopoverContext.Provider value={false}>
        <div
          className={`${
            feiertage.length > 0 &&
            feiertage.some((f) => dayjs(f.datum).isSame(day, 'day'))
              ? 'mt-1'
              : 'mt-0'
          }`}>
          <FeiertagEntry day={day} />
        </div>
        {visible.map((termin) => (
          <div
            key={termin.id}
            onClick={(e) => e.stopPropagation()}
            className="cursor-pointer">
            <TerminEntry termine={[termin]} />
          </div>
        ))}
      </DayPopoverContext.Provider>
      {hidden.length > 0 && <DayPopover termine={hidden} day={day} />}
    </div>
  );
}
